import { AfterViewInit, Component, OnInit, AfterViewChecked, AfterContentInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-openings',
  templateUrl: './openings.component.html',
  styleUrls: ['./openings.component.css']
})
export class OpeningsComponent implements OnInit, AfterContentInit {
  authToken = localStorage.getItem('auth');

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };

  businessID = this.route.snapshot.params.businessID;
  type = this.route.snapshot.params.type;
  openings = [];
  allOpenings = [];
  views = 0;
  applicants = 0;
  len = 0;
  un_seen_openings = [];
  logo_url = "";
  isLoading = true;



  constructor(
    private fb: FormBuilder,
    private router: Router,
    private http: HttpClient,
    private route: ActivatedRoute,
    private authService: AuthService) { }


  //Listen if activated route changes
  ngAfterContentInit() {
    this.route.params.subscribe(params => {
      this.type = params['type'];
      //Fetch if 
      this.fetchOpenings();
    });
  }

  ngOnInit(): void {
    //this.fetchOpenings();
    var business = JSON.parse(localStorage.getItem('company_' + this.businessID));
    this.logo_url = business[0].logo;
    console.log(this.logo_url, business);

  }


  ngOndestroy(): void {
    console.log('ddd')
  }

  fetchOpenings() {

    if (this.type == 'standard') {
      var query = '?type=standard';
    }
    else if (this.type == 'quickapplication') {
      var query = '?type=quickapplication';
    }
    this.openings = [];
    this.allOpenings = [];
    this.http.get(environment.OPENINGS + query, this.httpOptions).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res.status == 200) {
          var op = res.message;
          this.allOpenings = op;
          this.len = op.length;

          for (let i = 0; i < op.length; i++) {
            var opening = op[i];

            if (opening['campaign_expires']) {
              var c_e = new Date(opening['campaign_expires']);

              if (c_e < new Date()) {
                op[i]['in_campaign'] = false;
              }
              else {
                op[i]['in_campaign'] = true;
              }
            }
            else {
              op[i]['in_campaign'] = false;
            }

            //check if application is ended
            if (opening['application_ends']) {
              var a_e = new Date(opening['application_ends']);

              if (a_e > new Date()) {
                op[i]['expired'] = false;
              }
              else {
                op[i]['expired'] = true;
              }
            }



          }

          //Sort openings so that in_campaign openings are first and then new_applications
          op.sort((a, b) => {
            if (a.in_campaign && !b.in_campaign) {
              return -1;
            } else if (!a.in_campaign && b.in_campaign) {
              return 1;
            } else if (a.new_application && !b.new_application) {
              return -1;
            } else if (!a.new_application && b.new_application) {
              return 1;
            } else {
              return 0;
            }
          });


          //Every 0.2sec insert opening to this.openings
          this.openings = op
          console.log(this.un_seen_openings)
        }
        else {
          this.openings = []
        }

      }, (err: any) => {

      }
    )
  }

  search(e) {

    var userInput = (<HTMLInputElement>document.getElementById('search-form')).value;
    var erase_button_key_code = 8;
    var event_key_code = e.keyCode;
    console.log(event_key_code)
    if (userInput.length >= 3 && event_key_code != 8) {
      this.protectApi()
    }
    else if (userInput.length == 0) {
      this.openings = this.allOpenings;
      this.len = this.allOpenings.length;
    }
  }

  protectApi() {
    //allow search every 1 sec
    var userInput = (<HTMLInputElement>document.getElementById('search-form')).value;
    var interval = setInterval(() => {
      //Prevent api call if user is still typing
      var userInput2 = (<HTMLInputElement>document.getElementById('search-form')).value;
      if (userInput != userInput2) {
        clearInterval(interval);
      }
      else {
        console.log(userInput, userInput2)
        this.searchApi(userInput2);
        clearInterval(interval);
      }
    }
      , 500);
  }

  searchApi(userInput) {
    this.http.get(environment.EMPLOYER_SEARCH_OPENING + '/' + this.type + '/' + userInput, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {

          var op = res.message;
          this.len = op.length;

          for (let i = 0; i < op.length; i++) {
            var opening = op[i];

            if (opening['campaign_expires']) {
              var c_e = new Date(opening['campaign_expires']);

              if (c_e < new Date()) {
                op[i]['in_campaign'] = false;
              }
              else {
                op[i]['in_campaign'] = true;
              }
            }
            else {
              op[i]['in_campaign'] = false;
            }



          }

          //Sort openings so that in_campaign openings are first and then new_applications
          op.sort((a, b) => {
            if (a.in_campaign && !b.in_campaign) {
              return -1;
            } else if (!a.in_campaign && b.in_campaign) {
              return 1;
            } else if (a.new_application && !b.new_application) {
              return -1;
            } else if (!a.new_application && b.new_application) {
              return 1;
            } else {
              return 0;
            }
          });

          this.openings = op;
        }
        else {
          this.openings = [];
        }

      }, (err: any) => {

        console.log("Error while login :: ", err);
      })
  }

  sortOpenings() {
    var sorting = (<HTMLInputElement>document.getElementById('sorting')).value;

    switch (sorting) {
      case 'newest_first':
        this.openings.sort((a, b) => {
          return new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime();
        });
        break;
      case 'expired_first':
        this.openings.sort((a, b) => {
          return new Date(a.application_ends).getTime() - new Date(b.application_ends).getTime();
        });
        break;
      case 'new_applications_first':
        this.openings.sort((a, b) => {
          if (a.new_application && !b.new_application) {
            return -1;
          } else if (!a.new_application && b.new_application) {
            return 1;
          }
          else {
            return 0;
          }

        }
        );
        break;

    }
  }



}
